import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const developerGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.user();

  if (user && user.role === 'Admin' && user.email === 'fvsalvamante@gmail.com') {
    return true;
  }

  return router.createUrlTree(['/login']);
};
